import { Form, Row, Col, Button } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';

const WorkflowActionCreate = ({ state, setState, onChange }: any) => {
  const { config } = state;

  const { message, subject, workflow_id, response_input_options = [], owner, variables = [] } = config || {};

  const createNewResponseInputOption = () => {
    setState({
      ...state,
      config: {
        ...config,
        response_input_options: [
          ...response_input_options,
          {
            id: uuidv4(),
            label: '',
          },
        ],
      },
    });
  };

  const deleteNewResponseInputOption = (id: any) => {
    const updatedOptions = response_input_options.filter((option: any) => option.id !== id);

    setState({
      ...state,
      config: {
        ...config,
        response_input_options: updatedOptions,
      },
    });
  };

  const updateResponseInputOption = (event: any, index: any) => {
    const { value } = event.target;
    const updated = [...response_input_options];
    updated[index] = { ...updated[index], label: value };

    setState({
      ...state,
      config: {
        ...config,
        response_input_options: updated,
      },
    });
  };

  return (
    <>
      <Form.Group className="mb-2 w-full" controlId="formNode-message">
        <Form.Label>Message</Form.Label>
        <Form.Control type="text" as="textarea" rows={3} name="message" value={message} onChange={(e) => onChange(e, true)} />
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-subject">
        <Form.Label>Subject</Form.Label>
        <Form.Control type="text" name="subject" value={subject} onChange={(e) => onChange(e, true)} />
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-workflow_id">
        <Form.Label>Workflow ID</Form.Label>
        <Form.Control type="text" name="workflow_id" value={workflow_id} onChange={(e) => onChange(e, true)} />
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-owner">
        <Form.Label>Owner</Form.Label>
        <Form.Control type="text" name="owner" value={owner} onChange={(e) => onChange(e, true)} />
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-response_input_options">
        <Form.Label>Response input options</Form.Label>
        {response_input_options.map((option: any, index: any) => (
          <div key={`${index}-${option.id}`} className="d-flex mb-2">
            <Form.Control type="text" name={option.id} value={option.label} onChange={(e) => updateResponseInputOption(e, index)} className="me-2" />
            <Button variant="secondary" onClick={() => deleteNewResponseInputOption(option.id)}>
              Delete
            </Button>
          </div>
        ))}
      </Form.Group>

      <Row className="mt-2">
        <Col>
          <Button onClick={createNewResponseInputOption}>Add new response input option</Button>
        </Col>
      </Row>
    </>
  );
};

export default WorkflowActionCreate;
